/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

//Insert any custom theme js here...


var productThumbHeight = function(){
  var proThumbWrapper = document.querySelector('.product-single__photos .product-single__photo__nav');
  var mainImageWrapper = document.querySelector('.product-single__photo');
  if (proThumbWrapper && mainImageWrapper) {
  var pTWHeight = proThumbWrapper.clientHeight;
  var mIWHeight = mainImageWrapper.clientHeight;
  proThumbWrapper.style.cssText = `max-height: ${mIWHeight}px;`; 
  proThumbWrapper.classList.add('proThumbScroll');
  }
};

 
$('.js-section__product-single .js-product-slider').on('init', function(event, slick){
  if (window.innerWidth > 767) {
    setTimeout(function(){
      productThumbHeight();
    }, 1000);
  }
});

window.addEventListener('resize', function(){
  if (window.innerWidth > 767) {
    productThumbHeight();
  };
});

// var ajaxInnerHeight = function(){
//   setTimeout(function(){
//    var cartContainer = document.querySelector('#CartContainer');
//   var cartBottom = document.querySelector('.cart_buttom');
//   var cartInner = document.querySelector('.ajaxcart__inner');
//   var cIHeight;
//   cIHeight = cartContainer.clientHeight - cartBottom.clientHeight;
//   cartInner.style.height = cIHeight + 'px';
//   },2000);
 
// };
// ajaxInnerHeight();
// window.addEventListener('resize', ajaxInnerHeight);